import startupConfig from '../lib/startupConfig';
import baseApi from './baseApi';

const get = (partUrl: string, apiVersion = ''): Promise<any> => {
  const config = startupConfig.get();
  const baseUrl = config ? config.paymentsUiUrl || '' : '';
  return baseApi.get({ url: `${baseUrl}/api${partUrl}`, apiVersion });
};

const post = (partUrl: string, data: any, apiVersion = ''): Promise<any> => {
  const config = startupConfig.get();
  const baseUrl = config ? config.paymentsUiUrl || '' : '';
  return baseApi.post({ url: `${baseUrl}/api${partUrl}`, data, apiVersion });
};

const getStartupConfig = (): Promise<any> => {
  return get('/configuration/startup');
};

const getCheckOutSummary = (checkOutId: string): Promise<any> => {
  return get(`/checkouts/${checkOutId}`);
};

const confirmPay = (checkOutId: string, buyerGcAccountId: string): Promise<any> => {
  return post(`/checkouts/${checkOutId}/confirm`, { buyerGcAccountId });
};

const getAccounts = (checkOutId: string): Promise<any> => {
  return get(`/accounts?checkoutId=${checkOutId}`);
};

const getAccountsToLink = (): Promise<any> => {
  return get('/link-accounts');
};

const getSupplierBuyerAssociation = (checkOutId: string, buyerGcAccountId: string): Promise<any> => {
  return get(`/supplierbuyer?buyerGcAccountId=${buyerGcAccountId}&checkoutId=${checkOutId}`);
};

const sendAuthenticationCode = (checkOutId: string, mobileNumber: string, context: string) =>
  post('/auth/code', { checkOutId, mobileNumber, context });

const getPaymentsTokenByAuthCode = (checkOutId: string, mobileNumber: string, code: string, context: string) =>
  post(`/auth/verify-code`, { checkOutId, mobileNumber, code, context });

const getLoanAgreementDetails = (checkOutId: string, buyerGcAccountId: string) =>
  get(`/loanagreements?checkoutId=${checkOutId}&buyerGcAccountId=${buyerGcAccountId}`);

const getAccountIntentSummary = (intentId: string): Promise<any> => {
  return get(`/payment-account-links/intent/${intentId}`);
};

const confirmLink = (intentId: string, buyerGcAccountId: string): Promise<any> => {
  return post(`/payment-account-links/${intentId}/confirm`, { buyerGcAccountId });
};

const declineCheckOut = (checkOutId: string): Promise<any> => {
  return post(`/checkouts/${checkOutId}/decline`, {});
};

export default {
  confirmPay,
  confirmLink,
  declineCheckOut,
  getStartupConfig,
  getCheckOutSummary,
  getSupplierBuyerAssociation,
  getAccounts,
  getAccountsToLink,
  getAccountIntentSummary,
  getLoanAgreementDetails,
  getPaymentsTokenByAuthCode,
  sendAuthenticationCode,
};
